import React, { useEffect, useCallback, useState } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import './style.scoped.css';
import TabBar from 'src/components/TabBar';
import Promotions from './Promotions';
import News from './News';
import i18n from 'src/lang/i18n';
const tabData = [{ name: i18n.t('promotion') }, { name: i18n.t('news') }];

const NewsAndPromotion = () => {
  const [tab, setTab] = useState<number>(0);
  const { t } = useTranslation();
  // const dispatch = useDispatch();

  // const _load = useCallback(() => {
  //   dispatch(requestEventAll());
  //   dispatch(requestAllPromotion());
  // }, [dispatch]);

  // // Add pull to refresh function
  // usePullToRefresh('.refreshContent', <Loading type={'small'} />, _load);
  // const loading = useSelector(selectLoadingAllEvent);
  // const allEvent = useSelector(selectAllEvent);
  // console.log('allEvent', allEvent);

  // useEffect(() => {
  //   _load();
  // }, [_load]);

  // const _handlePressItem = useCallback((item) => {
  //   sendOpenNewWebview(item);
  // }, []);

  // const _renderItem = (item, index) => {
  //   return (
  //     <div
  //       className={`item ${index < allEvent.length - 1 ? 'mb-4' : ''}`}
  //       style={{ backgroundImage: `url(${item.photo})` }}
  //       onClick={() => _handlePressItem(item)}
  //       key={item.id}
  //     >
  //       <div className="itemGradientLayer">
  //         <div className="flex items-center">
  //           <div className="name">{item.name}</div>

  //           {/* <div className="description">{item.description}</div> */}
  //           <div className="w-6 h-6 mr-2">
  //             <img src={forward} className="forwardIcon" />
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const _handleChangeTab = (tabIndex: number) => {
    setTab(tabIndex);
  };

  const _renderContent = () => {
    if (tab == 0) {
      return <Promotions />;
    }
    return <News />;
  };

  return (
    <div className="screenContainerWithoutButton bg-primaryVariant">
      <div>
        <Toolbar title={t('new_and_discount')} type={'onPrimary'} />
        <div className="h-3" />
        <div className="px-4 pb-6">
          <TabBar
            data={tabData}
            activeTab={tab}
            onChangeTab={_handleChangeTab}
          />
        </div>
      </div>
      {_renderContent()}
    </div>
  );
};

export default NewsAndPromotion;
